import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useRef, useState } from 'react';
import { Background } from "../../Background/Background";
import { Container } from "../../Container/Container/Container";
import { Tout } from "../../Tout/Tout/Tout";
import Browser from "../../Utility/Browser";
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import { Breakpoints } from "../../Responsive/Breakpoints/Breakpoints";
import styles from "./VideoMastheadSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var VideoMastheadSlice = function VideoMastheadSlice(_ref) {
  var background = _ref.background,
    tout = _ref.tout,
    _ref$minVideoHeightDe = _ref.minVideoHeightDesktop,
    minVideoHeightDesktop = _ref$minVideoHeightDe === void 0 ? 550 : _ref$minVideoHeightDe,
    _ref$topContentPaddin = _ref.topContentPaddingMobile,
    topContentPaddingMobile = _ref$topContentPaddin === void 0 ? 40 : _ref$topContentPaddin;
  var minVideoHeightMobile = 450;
  var minPaddingMobile = 40;
  var _useState = useState(minVideoHeightMobile),
    _useState2 = _slicedToArray(_useState, 2),
    contentHeightMobile = _useState2[0],
    setContentHeightMobile = _useState2[1];
  var _useState3 = useState(minVideoHeightDesktop),
    _useState4 = _slicedToArray(_useState3, 2),
    contentHeightDesktop = _useState4[0],
    setContentHeightDesktop = _useState4[1];
  var _useState5 = useState(minPaddingMobile),
    _useState6 = _slicedToArray(_useState5, 2),
    paddingTopMobile = _useState6[0],
    setPaddingTopMobile = _useState6[1];
  var contentRefMobile = useRef(null);
  var contentRefDesktop = useRef(null);
  var setBackgroundHeight = function setBackgroundHeight() {
    var _contentRefMobile$cur, _contentRefMobile$cur2, _contentRefDesktop$cu, _contentRefDesktop$cu2;
    var mobileContentHeight = contentRefMobile === null || contentRefMobile === void 0 ? void 0 : (_contentRefMobile$cur = contentRefMobile.current) === null || _contentRefMobile$cur === void 0 ? void 0 : (_contentRefMobile$cur2 = _contentRefMobile$cur.getBoundingClientRect()) === null || _contentRefMobile$cur2 === void 0 ? void 0 : _contentRefMobile$cur2.height;
    var desktopContentHeight = contentRefDesktop === null || contentRefDesktop === void 0 ? void 0 : (_contentRefDesktop$cu = contentRefDesktop.current) === null || _contentRefDesktop$cu === void 0 ? void 0 : (_contentRefDesktop$cu2 = _contentRefDesktop$cu.getBoundingClientRect()) === null || _contentRefDesktop$cu2 === void 0 ? void 0 : _contentRefDesktop$cu2.height;
    if (mobileContentHeight && window.innerWidth < Breakpoints.small.min) {
      setContentHeightMobile(Math.round(mobileContentHeight <= minVideoHeightMobile ? minVideoHeightMobile : mobileContentHeight));
    } else if (desktopContentHeight) {
      setContentHeightDesktop(Math.round(desktopContentHeight <= minVideoHeightDesktop ? minVideoHeightDesktop : desktopContentHeight));
    }
  };
  var setMobilePadding = function setMobilePadding() {
    if (window.innerWidth < Breakpoints.small.min) {
      setPaddingTopMobile(topContentPaddingMobile);
    }
  };
  var setVideoHeight = function setVideoHeight() {
    var _background$video;
    if (background !== null && background !== void 0 && (_background$video = background.video) !== null && _background$video !== void 0 && _background$video.desktop) {
      if (contentHeightDesktop > minVideoHeightDesktop) {
        background.video.desktop.height = contentHeightDesktop;
      } else {
        background.video.desktop.height = minVideoHeightDesktop;
      }
    }
  };
  var handleResizeFuncs = function handleResizeFuncs() {
    setMobilePadding();
    setBackgroundHeight();
    setVideoHeight();
  };
  useEffect(function () {
    if (Browser.isBrowser()) {
      // Component mount.
      window.addEventListener('resize', handleResizeFuncs);
      // Component unmount.
      return function () {
        window.removeEventListener('resize', handleResizeFuncs);
      };
    }
  });
  useEffect(function () {
    handleResizeFuncs();
  });
  var renderMobileContent = function renderMobileContent() {
    return /*#__PURE__*/_jsx("div", {
      className: styles.container,
      style: {
        height: contentHeightMobile
      },
      children: /*#__PURE__*/_jsx(Background, _objectSpread(_objectSpread({}, background), {}, {
        height: contentHeightMobile,
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx("div", {
            className: styles.content,
            ref: contentRefMobile,
            style: {
              minHeight: contentHeightDesktop <= minVideoHeightMobile ? contentHeightMobile : undefined,
              paddingTop: "".concat(paddingTopMobile, "px")
            },
            children: /*#__PURE__*/_jsx(Tout, _objectSpread({}, tout))
          })
        })
      }))
    });
  };
  var renderDesktopContent = function renderDesktopContent() {
    setVideoHeight();
    return /*#__PURE__*/_jsx("div", {
      className: styles.container,
      style: {
        height: contentHeightDesktop
      },
      children: /*#__PURE__*/_jsx(Background, _objectSpread(_objectSpread({}, background), {}, {
        height: contentHeightDesktop,
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx("div", {
            className: styles.content,
            ref: contentRefDesktop,
            style: {
              minHeight: contentHeightDesktop <= minVideoHeightDesktop ? contentHeightDesktop : undefined
            },
            children: /*#__PURE__*/_jsx(Tout, _objectSpread({}, tout))
          })
        })
      }))
    });
  };
  return /*#__PURE__*/_jsxs(Breakpoint, {
    breakpoint: 'small',
    children: [renderMobileContent(), renderDesktopContent()]
  });
};